import { getEncounterEvolutionNotePrint, resolveAbsoluteMediaUrl } from './api';
import { clinicLogo } from '../context/ClinicBrandingContext';
import {
  evolutionNotePrintHasContent,
  htmlPayloadFromApiPrint,
  mergeFormDraftIntoApiPrint,
  openEvolutionNotePreview,
} from './evolutionNoteDocument';

async function fetchMediaAsDataUrl(absoluteUrl) {
  if (!absoluteUrl) return '';
  try {
    const res = await fetch(absoluteUrl, { credentials: 'include', mode: 'cors' });
    if (!res.ok) return absoluteUrl;
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || absoluteUrl));
      reader.onerror = () => resolve(absoluteUrl);
      reader.readAsDataURL(blob);
    });
  } catch {
    return absoluteUrl;
  }
}

/**
 * Imprime nota de evolución: guarda en servidor (opcional formDraft), lee GET print-payload, abre PDF.
 * @param {string} encounterId
 * @param {object} [options]
 * @param {object} [options.clinicInfo] branding para logo si API no trae URL absoluta
 * @param {object} [options.formDraft] campos del formulario abierto (solo valores no vacíos)
 */
export async function printEvolutionNote(encounterId, options = {}) {
  const { clinicInfo, formDraft } = options;
  let apiPrint;
  try {
    apiPrint = await getEncounterEvolutionNotePrint(encounterId);
  } catch (err) {
    const detail = err?.response?.data?.detail;
    const message =
      typeof detail === 'string'
        ? detail
        : 'La nota no tiene contenido guardado. Guarde los cambios e intente de nuevo.';
    return { ok: false, reason: 'empty_content', message };
  }

  if (formDraft) {
    apiPrint = mergeFormDraftIntoApiPrint(apiPrint, formDraft);
  }

  if (!evolutionNotePrintHasContent(apiPrint)) {
    return {
      ok: false,
      reason: 'empty_content',
      message:
        'La nota no tiene contenido guardado. Guarde los cambios o complete la nota e intente de nuevo.',
    };
  }

  const logoFromApi = resolveAbsoluteMediaUrl(apiPrint.logo_url || '');
  const logoFromBranding = resolveAbsoluteMediaUrl(clinicLogo(clinicInfo));
  const logoAbsolute = logoFromApi || logoFromBranding;
  const logoDataUrl = logoAbsolute ? await fetchMediaAsDataUrl(logoAbsolute) : '';

  const payload = htmlPayloadFromApiPrint(apiPrint, logoDataUrl);
  return openEvolutionNotePreview(payload);
}
